/* eslint-disable no-nested-ternary */
/* eslint-disable prefer-destructuring */
import React, { useEffect, useState, Component } from 'react';
import axios from 'axios';
import cn from 'classnames';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  IdealBankElement,
  P24BankElement,
  EpsBankElement,
  Elements,
  ElementsConsumer,
} from '@stripe/react-stripe-js';
import { SvgIcon } from '@mui/material';
import { loadStripe } from '@stripe/stripe-js';
import { Button } from 'react-bootstrap';
import styles from './ticket-spot.scss';
import { WIX_INSTANCE_PARAMS } from '../../actions/component_actions';
import { StepButtonWrapper } from './checkout-stepper';
import { trackPaymentAttempt, trackPaymentResult } from '../../utils/journey-tracking';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentIcon from '@mui/icons-material/Payment';

const getPaymentMethods = (paymentMethods = {}) => {
  const activePaymentMethods = Object.keys(paymentMethods).filter((method) => paymentMethods[method]);
  return activePaymentMethods.length === 0 ? { card: true } : paymentMethods;
};
const IdealIcon = () => (
  <svg
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    focusable="false"
    className="p-Logo p-Logo--md TabIcon p-PaymentAccordionButtonIcon"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M0 2.75A2.75 2.75 0 0 1 2.75 0H10a8 8 0 1 1 0 16H2.75A2.75 2.75 0 0 1 0 13.25V2.75Z" fill="#fff" />
    <path
      d="M4.433 7.516a1.113 1.113 0 1 0 0-2.226 1.113 1.113 0 0 0 0 2.226ZM5.273 12.004a1.683 1.683 0 0 1-1.685-1.684V9.004a.845.845 0 1 1 1.69 0v3h-.005Z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 2.75C1 1.784 1.784 1 2.75 1H10a7 7 0 1 1 0 14H2.75A1.75 1.75 0 0 1 1 13.25V2.75ZM2.75 2a.75.75 0 0 0-.75.75v10.5c0 .414.336.75.75.75H10a6 6 0 0 0 0-12H2.75Z"
      fill="#000"
    />
    <path d="M6.55 4.56V12h3.238c2.94 0 4.214-1.66 4.214-4.009C14.002 5.744 12.727 4 9.788 4H7.11a.562.562 0 0 0-.561.56Z" fill="#E60073" />
  </svg>
);

const BanContactIcon = () => (
  <svg
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    focusable="false"
    className="p-Logo p-Logo--md TabIcon p-PaymentAccordionButtonIcon"
  >
    <path
      d="M8.034 9.023c-1.784 2.37-3.938 5.023-8.034 5.023H1a1 1 0 0 1-1-1V8.023a1 1 0 0 1 1-1h12C8.034 4.653 16.94 2 21.034 2H26a1 1 0 0 1 1 1v5.023a1 1 0 0 1-1 1H14Z"
      fill="#fff"
    />
    <path d="M5.966 13.046c3.767 0 5.65-2.512 7.534-5.023H1v5.023h4.966Z" fill="url(#sjs-ui17443)" />
    <path d="M14.034 3c-3.767 0-5.65 2.511-7.534 5.023H14V3h-.966Z" fill="url(#sjs-ui17444)" />
    <defs>
      <linearGradient id="sjs-ui17443" x1="3.528" y1="10.766" x2="12.673" y2="7.37" gradientUnits="userSpaceOnUse">
        <stop stopColor="#005AB9" />
        <stop offset="1" stopColor="#1E3764" />
      </linearGradient>
      <linearGradient id="sjs-ui17444" x1="14.257" y1="8.458" x2="13.966" y2="5.146" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FBA900" />
        <stop offset="1" stopColor="#FFD800" />
      </linearGradient>
    </defs>
  </svg>
);

const EPSIcon = () => (
  <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" focusable="false">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.34 13.09a1.817 1.817 0 0 1-1.147.407H1.817C.8 13.497 0 12.647 0 11.659V6.254c0-.896.645-1.62 1.48-1.777a.897.897 0 0 1-.11-.42v-.765C1.423 1.62 2.817.3 4.504.3 6.223.3 7.64 1.67 7.64 3.389v.669c0 .157-.043.3-.11.42.843.16 1.48.905 1.48 1.79l-.001.6a3.552 3.552 0 0 1 2.898-1.504c1.237 0 2.32.635 2.957 1.594a2.5 2.5 0 0 1 2.326-1.594h3.538v2.808h-.047c.518.463.844 1.137.844 1.88 0 1.354-1.091 2.507-2.46 2.527H11.17V15.7H8.34v-2.61Z"
      fill="#fff"
    />
    <path
      d="M11.54 8.237c.974.014 1.771.83 1.771 1.814 0 .985-.797 1.814-1.77 1.828h-5.291c.66-.276.986-.826 1.321-1.47h3.944a.364.364 0 0 0 .376-.36.374.374 0 0 0-.376-.374h-1.84c-.99 0-1.796-.812-1.796-1.805 0-.994.806-1.806 1.797-1.806h2.838v1.408H9.19a.39.39 0 0 0-.376.391c0 .208.169.374.376.374h1.864Zm-7.147-2.173c1.58 0 2.86 1.297 2.86 2.896 0 1.6-1.283 2.919-2.863 2.919h-1.433V15H4.04V8.965c0-1.599 1.287-2.9 2.867-2.9Zm0 4.346a1.44 1.44 0 0 0 1.442-1.45c0-.81-.647-1.469-1.442-1.469-.795 0-1.436.66-1.436 1.47v1.449h1.436Z"
      fill="#5F6360"
    />
    <path
      d="M4.511 11.879h3.782c-.09.52-.549.918-1.1.918H1.817c-.615 0-1.117-.52-1.117-1.138V6.254a1.11 1.11 0 0 1 1.117-1.108h5.376c.614 0 1.117.506 1.117 1.123l-.006 4.14H4.511c-.581 0-1.085-.275-1.334-.764h4.22v-.702a2.9 2.9 0 0 0-2.892-2.895c-1.35 0-2.486.94-2.796 2.203 0 0-.085.423-.085.698 0 .276.09.695.09.695.307 1.266 1.444 2.235 2.797 2.235Zm-.006-4.457c.579 0 1.082.356 1.332.815H3.172c.25-.459.754-.815 1.333-.815ZM6.94 3.389v.669c0 .086-.075.17-.163.17h-.896c-.088 0-.159-.084-.159-.17v-.67c0-.658-.545-1.194-1.217-1.194s-1.218.536-1.218 1.195v.669c0 .086-.077.17-.164.17h-.896c-.088 0-.157-.084-.157-.17v-.735C2.105 2.034 3.18 1 4.504 1 5.85 1 6.94 2.07 6.94 3.389Z"
      fill="#A41760"
    />
  </svg>
);

const pollPaymentIntentStatus = async ({ paymentIntentId, setConfirmationEmail, handleCheckoutError, event, session, checkoutValues }) => {
  const poll = async () => {
    try {
      const stripeUrl = `${process.env.EVENTVIEWER_SERVER}/api/v1/stripe/payment_intents/${paymentIntentId}/status${WIX_INSTANCE_PARAMS}`;

      const response = await axios.post(stripeUrl);
      const { status, result } = response.data;

      if (status === 'pending') {
        setTimeout(poll, 1000);
      } else if (status === 'success') {
        // Journey tracking for successful payment
        if (event) {
          trackPaymentResult(event, true, {
            order_id: result.order_id || paymentIntentId,
            payment_method: 'stripe',
            cart_id: session?.idempotency_key,
          });
        }

        // Prepare successful payment data for tracking
        const purchaseData = {
          event_category: 'Ticket',
          event_label: event?.get('name'),
          transaction_id: result.order_id || paymentIntentId,
          currency: event?.get('currency'),
          value: checkoutValues?.total || 0,
          payment_method: 'stripe',
        };

        // Google Analytics tracking for successful purchase
        if (window.gtag) {
          window.gtag('event', 'purchase', purchaseData);
        }

        // Facebook Pixel tracking for successful purchase
        if (window.fbq) {
          window.fbq('track', 'Purchase', {
            content_name: event?.get('name'),
            content_category: 'Ticket',
            content_type: 'product',
            currency: event?.get('currency'),
            value: checkoutValues?.total || 0,
            payment_method: 'stripe',
          });
        }

        setConfirmationEmail({ message: result.confirmation_message, order_confirmation_url: result.order_confirmation_url });
      } else if (status === 'failed') {
        // Journey tracking for payment failure
        if (event) {
          trackPaymentResult(event, false, {
            error_message: result.error,
            payment_method: 'stripe',
          });
        }

        // Google Analytics tracking for payment error
        if (window.gtag) {
          window.gtag('event', 'payment_error', {
            event_category: 'Ticket',
            event_label: event?.get('name'),
            error_message: result.error,
            payment_method: 'stripe',
          });
        }

        // Facebook Pixel tracking for payment error
        if (window.fbq) {
          window.fbq('trackCustom', 'PaymentError', {
            content_name: event?.get('name'),
            content_category: 'Ticket',
            payment_method: 'stripe',
            error_message: result.error,
          });
        }

        handleCheckoutError({ errorMessage: result.error });
      }
    } catch (error) {
      // Journey tracking for payment error
      if (event) {
        trackPaymentResult(event, false, {
          error_message: error.message,
          payment_method: 'stripe',
        });
      }

      // Google Analytics tracking for payment error
      if (window.gtag) {
        window.gtag('event', 'payment_error', {
          event_category: 'Ticket',
          event_label: event?.get('name'),
          error_message: error.message,
          payment_method: 'stripe',
        });
      }

      // Facebook Pixel tracking for payment error
      if (window.fbq) {
        window.fbq('trackCustom', 'PaymentError', {
          content_name: event?.get('name'),
          content_category: 'Ticket',
          payment_method: 'stripe',
          error_message: error.message,
        });
      }

      handleCheckoutError({ errorMessage: error.message });
    }
  };

  poll();
};

export class StripePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      error: null,
      selectedPaymentMethod: 0,
    };
  }

  handleTabChange = (event, newValue) => {
    this.setState({ selectedPaymentMethod: newValue });
  };

  confirmPayment = async (stripeInstance, paymentMethod, clientSecret) => {
    const successUrl = `${process.env.EVENTVIEWER_SERVER}/api/v1/stripe/payment_intents/success${WIX_INSTANCE_PARAMS}`;
    let confirmation;
    switch (paymentMethod) {
      case 'card':
        confirmation = await stripeInstance.confirmCardPayment(clientSecret);
        break;
      case 'ideal':
        confirmation = await stripeInstance.confirmIdealPayment(
          clientSecret,
          { return_url: successUrl },
          {
            handleActions: false,
          }
        );
        if (confirmation.paymentIntent.next_action && confirmation.paymentIntent.next_action.redirect_to_url) {
          const url = confirmation.paymentIntent.next_action.redirect_to_url.url;
          window.open(url);
        }

        break;
      case 'p24':
        confirmation = await stripeInstance.confirmP24Payment(
          clientSecret,
          { return_url: successUrl },
          {
            handleActions: false,
          }
        );
        if (confirmation.paymentIntent.next_action && confirmation.paymentIntent.next_action.redirect_to_url) {
          const url = confirmation.paymentIntent.next_action.redirect_to_url.url;
          window.open(url);
        }
        break;
      case 'eps':
        confirmation = await stripeInstance.confirmEpsPayment(
          clientSecret,
          { return_url: successUrl },
          {
            handleActions: false,
          }
        );
        if (confirmation.paymentIntent.next_action && confirmation.paymentIntent.next_action.redirect_to_url) {
          const url = confirmation.paymentIntent.next_action.redirect_to_url.url;
          window.open(url);
        }
        break;
      case 'bancontact':
        confirmation = await stripeInstance.confirmBancontactPayment(
          clientSecret,
          { return_url: successUrl },
          {
            handleActions: false,
          }
        );
        if (confirmation.paymentIntent.next_action && confirmation.paymentIntent.next_action.redirect_to_url) {
          const url = confirmation.paymentIntent.next_action.redirect_to_url.url;
          window.open(url);
        }
        break;
      case 'twint':
        confirmation = await stripeInstance.confirmTwintPayment(
          clientSecret,
          { return_url: successUrl },
          {
            handleActions: false,
          }
        );
        break;
      default:
        throw new Error('Unsupported payment method');
    }

    if (confirmation.error) {
      throw confirmation.error;
    }

    return confirmation;
  };

  handlePayment = async (ev) => {
    ev.preventDefault();
    const {
      cart,
      form,
      stripeInstance,
      elements,
      onSave,
      onFail,
      eventId,
      event,
      promo_code,
      session,
      attendees,
      ticketOverrides,
      setConfirmationEmail,
      handleCheckoutError,
      checkoutValues,
    } = this.props;

    const { first_name, last_name, email } = form;
    this.setState({ processing: true, error: null });
    onSave();

    // Prepare tracking data
    const eventData = {
      event_category: 'Ticket',
      event_label: event?.get('name'),
      currency: event?.get('currency'),
      payment_method: 'stripe',
      cart_id: session?.idempotency_key,
    };

    // Google Analytics tracking
    if (window.gtag) {
      window.gtag('event', 'begin_payment', eventData);
    }

    // Facebook Pixel tracking
    if (window.fbq) {
      window.fbq('trackCustom', 'InitiatePayment', {
        content_name: event?.get('name'),
        content_category: 'Ticket',
        payment_method: 'stripe',
        currency: event?.get('currency'),
        value: checkoutValues?.total || 0,
      });
    }

    // Journey tracking for payment attempt
    if (event) {
      trackPaymentAttempt(event, { cart_id: session?.idempotency_key });
    }

    try {
      const billingDetails = { email, name: `${first_name} ${last_name}` };
      const paymentMethodsWithDefault = getPaymentMethods(this.props.payment_methods);
      const activePaymentMethods = Object.keys(paymentMethodsWithDefault).filter((method) => paymentMethodsWithDefault[method]);
      const paymentMethod = activePaymentMethods[this.state.selectedPaymentMethod];

      const paymentMethodResult = await stripeInstance.createPaymentMethod({
        type: paymentMethod,
        card: paymentMethod === 'card' ? elements.getElement(CardNumberElement) : undefined,
        ideal: paymentMethod === 'ideal' ? elements.getElement(IdealBankElement) : undefined,
        billing_details: billingDetails,
      });

      if (paymentMethodResult.error) {
        throw paymentMethodResult.error;
      }

      const { data } = await axios.post(
        `${process.env.EVENTVIEWER_SERVER}/api/v1/stripe/create-payment-intent${WIX_INSTANCE_PARAMS}`,
        {
          payment_method_id: paymentMethodResult.paymentMethod.id,
          payment_method: paymentMethod,
          contact: form,
          cart,
          event_id: eventId,
          promo_code,
          idempotency_key: session.idempotency_key,
          attendees,
          ticket_overrides: ticketOverrides,
        },
        { withCredentials: true }
      );

      const { client_secret } = data;

      const confirmation = await this.confirmPayment(stripeInstance, paymentMethod, client_secret);
      if (confirmation.error) {
        throw confirmation.error;
      }

      await pollPaymentIntentStatus({
        paymentIntentId: data.id,
        setConfirmationEmail,
        handleCheckoutError,
        event,
        session,
        checkoutValues,
      });
    } catch (error) {
      console.error(error);
      const errorMessage = error?.response?.data || error?.message || 'Unknown Error';
      this.setState({ error: errorMessage, processing: false });
      onFail();

      // Track payment error
      if (event) {
        trackPaymentResult(event, false, {
          error_message: errorMessage,
          payment_method: 'stripe',
        });
      }

      // Google Analytics tracking for payment error
      if (window.gtag) {
        window.gtag('event', 'payment_error', {
          ...eventData,
          error_message: errorMessage,
        });
      }

      // Facebook Pixel tracking for payment error
      if (window.fbq) {
        window.fbq('trackCustom', 'PaymentError', {
          content_name: event?.get('name'),
          content_category: 'Ticket',
          payment_method: 'stripe',
          error_message: errorMessage,
        });
      }
    }
  };

  renderPaymentMethod = (method) => {
    const ELEMENT_OPTIONS = {
      style: {
        base: {
          color: 'black',
          fontSize: '16px',
          height: '30px',
          backgroundColor: '#fff',
          fontFamily: 'Kumbh Sans, sans-serif',
          '::placeholder': {
            color: '#aab7c4',
          },
          '::selection': {
            backgroundColor: '#fff',
          },
        },
      },
    };

    const ElementComponent = method === 'ideal' ? IdealBankElement : method === 'p24' ? P24BankElement : method === 'eps' ? EpsBankElement : null;

    if (!ElementComponent) {
      return null;
    }

    return (
      <div className={styles.paymentFormElement} key={method}>
        <div className={styles.cardContainer}>
          <ElementComponent options={ELEMENT_OPTIONS} />
        </div>
      </div>
    );
  };

  render() {
    const { payment_methods, settings, onBack, session, onPaymentSubmit, checkoutValues } = this.props;
    const { processing, error, selectedPaymentMethod } = this.state;
    const paymentMethodsWithDefault = getPaymentMethods(payment_methods);

    const activePaymentMethods = Object.keys(paymentMethodsWithDefault).filter((method) => paymentMethodsWithDefault[method]);

    if (+checkoutValues.cartTotal === 0) {
      return (
        <div className={styles.paymentButtonContainer}>
          <StepButtonWrapper>
            <Button variant="outline-dark" onClick={onBack} className="checkout-prev-button">
              {settings.get('checkoutBackButtonText')}
            </Button>
          </StepButtonWrapper>
          <Button onClick={() => onPaymentSubmit({ idempotency_key: session.idempotency_key })}>Submit</Button>
        </div>
      );
    }

    const paymentMethodsDisplayNames = {
      card: 'Card',
      ideal: 'iDEAL',
      p24: 'Przelewy24',
      eps: 'EPS',
      bancontact: 'Bancontact',
    };

    return (
      <div className={styles.marginTop}>
        <form id="payment-form" className={styles.paymentWrapper}>
          {(activePaymentMethods.length > 1 || (activePaymentMethods.length === 1 && activePaymentMethods[0] !== 'card')) && (
            <Tabs value={selectedPaymentMethod} onChange={this.handleTabChange} aria-label="payment method tabs">
              {activePaymentMethods.map((method) => (
                <Tab
                  disableFocusRipple={false}
                  key={method}
                  icon={
                    method === 'card' ? (
                      <CreditCardIcon />
                    ) : method === 'ideal' ? (
                      <SvgIcon>
                        <IdealIcon />
                      </SvgIcon>
                    ) : method === 'p24' ? (
                      <PaymentIcon />
                    ) : method === 'eps' ? (
                      <SvgIcon>
                        <EPSIcon />
                      </SvgIcon>
                    ) : method === 'bancontact' ? (
                      <SvgIcon>
                        <BanContactIcon />
                      </SvgIcon>
                    ) : null
                  }
                  label={<span style={{ textTransform: 'none' }}>{paymentMethodsDisplayNames[method]}</span>}
                />
              ))}
            </Tabs>
          )}
          <div className={styles.paymentForm}>
            {activePaymentMethods[selectedPaymentMethod] === 'card' ? (
              <>
                <div className={cn(styles.paymentFormElement, styles.card)}>
                  <label className="checkout-form-field">{settings.get('cardNumberText')}</label>
                  <div className={styles.cardContainer}>
                    <CardNumberElement />
                  </div>
                </div>
                <div className={styles.paymentSecondInfoContainer}>
                  <div className={cn(styles.paymentFormElement, styles.small)}>
                    <label className="checkout-form-field">{settings.get('cardExpiryText')}</label>
                    <div className={styles.cardContainer}>
                      <CardExpiryElement />
                    </div>
                  </div>
                  <div className={cn(styles.paymentFormElement, styles.small)}>
                    <label className="checkout-form-field">{settings.get('cardSecurityCodeText')}</label>
                    <div className={styles.cardContainer}>
                      <CardCvcElement />
                    </div>
                  </div>
                </div>
              </>
            ) : (
              this.renderPaymentMethod(activePaymentMethods[selectedPaymentMethod])
            )}
          </div>
          <div className={styles.confirmQuestionsButton}>
            <div className={styles.paymentButtonContainer}>
              <StepButtonWrapper>
                <Button variant="outline-dark" onClick={onBack} className="checkout-prev-button checkout-back-button" disabled={processing}>
                  {settings.get('checkoutBackButtonText')}
                </Button>
                {React.cloneElement(this.props.children, {
                  disabled: this.state.processing,
                  onClick: this.handlePayment,
                })}
              </StepButtonWrapper>
            </div>
          </div>
          {error && <span className={styles.error}>{error}</span>}
        </form>
      </div>
    );
  }
}

const InjectedCheckoutForm = (props) => (
  <ElementsConsumer>{({ stripe, elements }) => <StripePayment stripeInstance={stripe} elements={elements} {...props} />}</ElementsConsumer>
);

export const StripePaymentForm = (props) => {
  const [stripeInstance, setStripeInstance] = useState(null);

  useEffect(() => {
    const loadStripeInstance = async () => {
      const stripe = await loadStripe(
        process.env.STRIPE_PUBLISHABLE_KEY,
        props.is_marketplace ? undefined : { stripeAccount: props.stripe_account_id }
      );
      setStripeInstance(stripe);
    };

    loadStripeInstance();
  }, [props.is_marketplace, props.stripe_account_id]);

  if (!stripeInstance) return <div>Loading...</div>;

  return (
    <Elements stripe={stripeInstance}>
      <InjectedCheckoutForm {...props} />
    </Elements>
  );
};
